import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'CUSTOMER_ZONE_FORM'
export const ZoneFormAction = createFormAction(FORM_KEY)

export const FORM_CODE_KEY = 'CUSTOMER_PARENT_CODE_FORM'
export const CodeFormAction = createFormAction(FORM_CODE_KEY)

export const FORM_STATION_KEY = 'CUSTOMER_STATION_FORM'
export const StationFormAction = createFormAction(FORM_STATION_KEY)